import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WristbandsService } from '@app/shared/services/wristbands.service';

import { ApiService, AuthenticationService, ThemeService } from '@shared/services';

import { saveAs } from 'file-saver';

@Component({
  selector: 'app-reserved-tickets',
  templateUrl: './reserved-tickets.component.html',
  styleUrls: ['./reserved-tickets.component.scss'],
  standalone: false
})
export class ReservedTicketsComponent implements OnInit {
  accountId: string;
  eventId: string;
  wristbandId: string;
  reservedTickets = [];
  loading = true;
  headerText = (localStorage.getItem('lang') === 'es') ? 'Entradas reservadas' : 'Reserved tickets';
  noTicketsText = (localStorage.getItem('lang') === 'es') ? 'No tienes entradas reservadas' : 'You have no reserved tickets';

  constructor(
    private apiService: ApiService,
    private authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<ReservedTicketsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public wristbandsService: WristbandsService,
    public themeService: ThemeService) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.accountId = this.data.accountId;
    this.eventId = this.data.eventId;
    this.wristbandId = this.data.wristbandId;
    this.loadReservedTickets();
  }

  loadReservedTickets() {
    this.loading = true;
    const url = `accounts/${this.accountId}/events/${this.eventId}/tickets/wristbands/${this.wristbandId}/tickets`;
    this.apiService.get(url).subscribe(
      data => {
        this.reservedTickets = data.data;
        this.reservedTickets.forEach(ticket => {
          ticket.tickets.forEach(ticket => {
            if (ticket.data) {
              ticket.data = JSON.parse(ticket.data);
            }
          });
        });
        this.loading = false;
      },
      err => {
        console.error(err);
        this.reservedTickets = [];
        this.loading = false;
      }
    );
  }

  getValues(data: any) {
    return Object.values(data);
  }

  onGoBack() {
    this.dialogRef.close();
  }

  maxLength(text: string, length: number): string {
    if (!text) {
      return '';
    }
    return text.substring(0, length);
  }

  downloadQrCode(ticketId: string) {
    this.loading = true;
    this.apiService.download(`accounts/${this.accountId}/events/${this.eventId}/tickets/${ticketId}/downloadPdf`).subscribe(
      data => {
        const filename = `Ticket_${this.wristbandsService.selectedEvent.name.replace(/ /g, '_')}.pdf`;
        const blob: any = new Blob([data], { type: 'application/pdf;charset=UTF-8; charset=utf-8' });
        saveAs(blob, filename);
        this.loading = false;
      },
      err => {
        console.error(err);
        this.loading = false;
      }
    );
  }
}

